const mParticleAudienceDataMock = {
    audienceMemberships: [19584, 21276, 21569],
    userAttributes: {
        registration_type: 'google',
        account_created: '2025-11-29 22:24:15',
        last_active_date: '2026-09-04T14:08:36Z',
        receive_marketing: null,
        email_validated: 'True',
        primary_email_address: 'mock.user@example.com',
        telephone_country_code: null,
        telephone_local_number: null,
        country: null,
        address1: null,
        address2: null,
        town: null,
        county_or_state: null,
        postcode: null,
        registration_location: 'United States',
        registration_location_state: 'Massachusetts',
        $firstname: 'Mock',
        $lastname: 'User',
        title: null,
        has_password: 'False',
        is_jobs_user: 'False',
        registration_platform: 'android_live_app',
        inferred_country: null,
        inferred_marketing_region: null,
        last_active_product_date: null,
        last_active_product_name: null,
        updated_at: '2026-09-06',
        count_active_products: '1',
        count_active_newsletters: '0',
        count_active_preferences: '0',
        this_month_engagement_score: '2.7',
        this_month_engagement_segment: 'Low',
        this_month_habit_score_week_start_date: '2026-04-25',
        last_month_engagement_score: '1.2',
        last_month_engagement_segment: 'Low',
        active_products: ['Single Contribution'],
        active_newsletters: null,
        active_preferences: null,
        social_links: ['google'],
        max_consented_timestamp: '2025-12-04 16:01:04',
        meta_created_at: '2026-04-17 12:46:01.001020',
        max_consent_timestamp: '2025-12-04 16:01:04',
        recurring_contribution_acquisition_date: null,
        recurring_contribution_amount: null,
        recurring_contribution_status: null,
        membership_status: null,
        supporter_plus_status: null,
        digital_pack_status: null,
        guardian_weekly_status: null,
        voucher_status: null,
        subscription_card_status: null,
        home_delivery_status: null,
        guardian_weekly_gift_status: null,
        guardian_ad_lite_status: null,
        tier_three_status: null,
        national_delivery_status: null,
        digital_pack_gift_status: null,
        premium_app_status: null,
        feast_app_status: null,
        disengagement_risk_flag: 'False',
        patron_type: null,
        patron_status: null,
        post_optin_consented: 'True',
        phone_optin_consented: 'True',
        profiling_optin_consented: 'True',
        market_research_optin_consented: 'True',
        first_act_of_support: '2025-12-04',
        last_logged_in_pageview_date: null,
        guardian_weekly_visited_checkout: null,
        paper_subscriptions_visited_checkout: null,
        contributions_visited_checkout: '2026-09-04T15:53:04.5480000Z',
        first_single_contribution_date: '2025-12-04T16:01:04.217Z',
        last_single_contribution_amount: '23',
        last_single_contribution_currency: 'GBP',
        contribution_count: '1',
        last_single_contribution_date: '2025-12-04T16:01:04.217Z',
        mpC_All_MostVisitedVerticalAnnual: 'World news',
        mpC_All_MostVisitedPillarAnnual: 'News',
        mpC_All_All_Global_MostVisitedVerticalLast30Days: 'World news',
        mpC_All_All_Global_PillarArts30Days: '1',
        mpC_All_All_Global_PillarNews30Days: '11',
        mpC_All_All_Global_PillarSport30Days: '2',
        mpC_All_All_Global_SectionWorldNews30Days: '6',
        mpC_All_All_Global_SectionPolitics30Days: '1',
        mpC_All_All_Global_SectionSociety30Days: '1',
        mpC_All_All_Global_SectionMusic30Days: '1',
        mpC_All_All_Global_ContentTypeLiveblog30Days: '5',
        mpC_All_All_Global_ContentTypeArticle30Days: '6',
        mpC_All_All_Global_VisitedDayMonday30Days: '8',
        mpC_All_All_Global_VisitedDayTuesday30Days: '11',
        mpC_All_All_Global_LastNewsPillarPageviewDate: '2026-08-30T00:00:00.000Z',
        mpC_LastSectionPageviewDate_Worldnews: '2026-08-30T00:00:00.000Z',
        mpC_LastSectionPageviewDate_Opinion: '2026-03-01T00:00:00.000Z',
        mpC_LastSectionPageviewDate_Politics: '2026-08-30T00:00:00.000Z',
        mpC_LastDevicePageviewDate_Desktop: '2026-08-30T00:00:00.000Z',
        mpC_LastDevicePageviewDate_Smartphone: '2026-08-23T00:00:00.000Z',
        mpC_All_SU_Global_LastSignedInWeek: '2026-08-30T00:00:00.0000000Z',
        mpC_Singles_CN_Global_SingleAverage365DaysTransationCurrency: '1',
        mpC_Singles_CN_Global_SingleAverage2YearsTransationCurrency: '1',
    },
};
export default mParticleAudienceDataMock;
